module.exports = __webpack_public_path__ + "media/application/images/ui/blurred_how_we_test-665176352937d2cddc1714e9bc39b38c.png";